module.exports = __webpack_public_path__ + "img/craft-category-icon.69f02b3e.svg";